<p class="ttl-2 sub ta:c">
  <span class="dp:blk">{{ textTop }}</span>
  <span class="dp:blk">{{ textBottom }}</span>
</p>
